import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import {
  GeoJSON,
} from 'react-leaflet';
import red from '@material-ui/core/colors/red';
import dataJSON from '../../assets/map/geojson/amphoe.json';

export default function LayerAmphoe(props) {
  const refBoundaryAmphoe = useRef();

  const [geojson, setGeojson] = useState(null);

  useEffect(() => {
    setGeojson(dataJSON);
  }, []);

  function getStyle(feature) {
    const {
      areaType, riskAreasId, areaFill, areaFillColor, areaFillOpacity,
    } = props;

    if (areaType.toString() === '0' && riskAreasId.length > 0) {
      if (riskAreasId.includes(feature.properties.AMPHOE_IDN)) {
        return {
          stroke: true,
          color: areaFill ? areaFillColor : red[900],
          weight: 2,
          fillColor: areaFill ? areaFillColor : red[500],
          fillOpacity: areaFill ? areaFillOpacity : 0.75,
        };
      }
    }

    return {
      stroke: false,
      fillColor: '#FFF',
      fillOpacity: 0,
    };
  }

  const onEachFeature = (feature, layer) => {
    const { areaType, riskAreasId } = props;

    if (areaType.toString() === '0' && riskAreasId.length > 0) {
      if (riskAreasId.includes(feature.properties.AMPHOE_IDN)) {
        layer.bindTooltip(`${feature.properties.AMPHOE_T} ${feature.properties.PROV_NAM_T}`);
      }
    }
  };

  return (
    <GeoJSON
      key={uniqueId()}
      data={geojson}
      style={getStyle}
      ref={refBoundaryAmphoe}
      onEachFeature={onEachFeature}
    />
  );
}

LayerAmphoe.defaultProps = {
  areaId: '',
  areaFill: false,
  areaFillColor: '',
  areaFillOpacity: 0,
};

LayerAmphoe.propTypes = {
  areaType: PropTypes.number.isRequired,
  riskAreasId: PropTypes.instanceOf(Array).isRequired,
  areaFill: PropTypes.bool,
  areaFillColor: PropTypes.string,
  areaFillOpacity: PropTypes.number,
};
